import { render, staticRenderFns } from "./ProductSelection.vue?vue&type=template&id=64107a0b&scoped=true"
import script from "./ProductSelection.vue?vue&type=script&lang=js"
export * from "./ProductSelection.vue?vue&type=script&lang=js"
import style0 from "./ProductSelection.vue?vue&type=style&index=0&id=64107a0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64107a0b",
  null
  
)

export default component.exports